import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import LandingPage from "./components/landing/LandingPage";
import AboutPage from "./pages/AboutPage";
import PurposePage from "./pages/PurposePage";
import TrainingsPage from "./pages/TrainingsPage";
import ProjectsPage from "./pages/ProjectsPage";
import EventsPage from "./pages/EventsPage";
import OpportunitiesPage from "./pages/OpportunitiesPage";
import NewsDetailPage from "./pages/NewsDetailPage";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/amac" element={<PurposePage />} />
            <Route path="/egitimler" element={<TrainingsPage />} />
            <Route path="/projeler" element={<ProjectsPage />} />
            <Route path="/etkinlikler" element={<EventsPage />} />
            <Route path="/firsatlar" element={<OpportunitiesPage />} />
            <Route path="/haber/:id" element={<NewsDetailPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
